import React from 'react';

import './style.less';
import { Col, Collapse, Row } from 'antd';

const { Panel } = Collapse;

const LeadPageFaq = ({ data, image, id }) => {
  return (
    <div className="lead-page-large-section lead-page-faq" id={id}>
      <Row>
        <Col md={{ span: 24 }} lg={{ span: 6 }}>
          <div className="hidden lg:block">
            <img
              alt="FAQ"
              style={{ width: 263, height: 549 }}
              src={image}
              loading="lazy"
            />
          </div>
        </Col>
        <Col md={{ span: 24 }} lg={{ span: 18 }} className="pl-0 lg:pl-4">
          <h2 className="text-center">FAQ</h2>
          <Collapse accordion>
            {data.map((faqItem, index) => (
              <Panel
                header={
                  <div className="os-text-18 font-semibold leading-snug">
                    {faqItem.title}
                  </div>
                }
                showArrow={false}
                forceRender
                key={index}
              >
                <div className="os-text-17">{faqItem.content}</div>
              </Panel>
            ))}
          </Collapse>
        </Col>
      </Row>
    </div>
  );
};

export default LeadPageFaq;
